import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function AlphabetIcon(props: IconProps): ReactElement {
  const { width = 22, height = 19, className = "" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 19"
      fill="none"
      className={className}
      width={width}
      height={height}
    >
      <path
        d="M6.08394 0.0684H6.03666L6.06042 0L6.08394 0.0684ZM20.8437 15.2021C20.9795 15.3017 21.0602 15.4594 21.0602 15.6278V17.3338C21.0602 17.6314 20.7585 17.8318 20.482 17.7211C19.9336 17.5015 19.4354 17.184 19.0082 16.789C18.3302 17.5906 17.3102 18.0941 16.1747 18.0677C14.2036 18.0216 12.6602 16.3418 12.6602 14.37V10.8686C12.6602 8.88048 14.272 7.26864 16.2602 7.26864H18.6602C19.3228 7.26864 19.8602 7.806 19.8602 8.46864V13.2686C19.8602 14.0621 20.2483 14.7653 20.8437 15.2021ZM17.4602 9.6684H16.2602C15.5985 9.6684 15.0602 10.2067 15.0602 10.8684V14.4684C15.0602 15.1301 15.5985 15.6684 16.2602 15.6684C16.9219 15.6684 17.4602 15.1301 17.4602 14.4684V9.6684ZM7.49778 4.15296L12.0943 17.4314C12.2023 17.7432 11.9707 18.0684 11.6407 18.0684H10.1975C9.94458 18.0684 9.71946 17.9081 9.6369 17.669L8.52906 14.4684H3.59202L2.48418 17.669C2.40138 17.9081 2.17626 18.0684 1.92354 18.0684H0.480422C0.150422 18.0684 -0.0811777 17.7432 0.0268223 17.4314L4.62282 4.15296C4.72314 3.86304 4.99626 3.6684 5.30322 3.6684H6.81762C7.12458 3.6684 7.39746 3.8628 7.49778 4.15296ZM7.69818 12.0684L6.06042 7.3368L4.42266 12.0684H7.69818Z"
        fill="#A1A1A1"
      />
    </svg>
  );
}
